const ENReportsPanel = {
	"Novo relatório":"New report",
	"Demais relatórios":"Others reports",
	"Erro ao buscar agrupadores":"Error on search groupers",
	"Erro ao buscar relatórios":"Error on search reports",
	"Erro ao buscar permissões":"Error on search permissions",
	"Utilize as permissões para definir quais usuários, ou grupos de usuários, terão acesso a esse relatório":
	"Use permissions to set the user/user group and their permission to view the report"
};

export default ENReportsPanel;
